module.exports = __webpack_public_path__ + "img/Linkcard_Logo_Footer.34f8e9e.svg";